<template>
  <div class="card green">
    <div class="content">
      <div class="header">
        {{ $t('CRON') }}
        <i class="right floated clock icon"></i>
      </div>
      <div class="meta">
        {{ trigger.configuration && trigger.configuration.cron }}
      </div>
    </div>
    <div class="primary content">
      <div class="ui tiny info message">
        <i class="idea icon"></i>
        {{ $t('CRON_HUMAN_DESC') }} {{ humanCron }}. {{ $t('CRON_NEXT') }} {{ nextCronScheduled }}.
      </div>
      <div class="field">
        <label for="cronSecond">{{ $t('CRON_SECOND') }}</label>
        <input id="cronSecond" type="text" placeholder="0" v-model="cronFields.second" />
      </div>
      <div class="field">
        <label for="cronMinute">{{ $t('CRON_MINUTE') }}</label>
        <input id="cronMinute" type="text" placeholder="*" v-model="cronFields.minute" />
      </div>
      <div class="field">
        <label for="cronHour">{{ $t('CRON_HOUR') }}</label>
        <input id="cronHour" type="text" placeholder="*" v-model="cronFields.hour" />
      </div>
      <div class="field">
        <label for="cronDayOfMonth">{{ $t('CRON_DAYOFMONTH') }}</label>
        <input id="cronDayOfMonth" type="text" placeholder="*" v-model="cronFields.day" />
      </div>
      <div class="field">
        <label for="cronMonth">{{ $t('CRON_MONTH') }}</label>
        <input id="cronMonth" type="text" placeholder="*" v-model="cronFields.month" />
      </div>
      <div class="field">
        <label for="cronDayOfWeek">{{ $t('CRON_DAYOFWEEK') }}</label>
        <input id="cronDayOfWeek" type="text" placeholder="*" v-model="cronFields.weekday" />
      </div>
      <div class="ui toggle checkbox">
        <input id="noLaunch" type="checkbox" v-model="trigger.configuration.noLaunch" />
        <label for="noLaunch">
          {{ $t('TRIGGER_NO_LAUNCH') }}
        </label>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../../../scss/variables';
.info.message,
.warning.message {
  display: block !important;
}
</style>

<script>
// @flow
import prettycron from 'prettycron'
import _ from 'lodash'

export default {
  name: 'crontrigger',
  props: {
    trigger: {
      type: Object,
      default: () => {
        return {
          configuration: {
            cron: '',
            noLaunch: false
          }
        }
      }
    }
  },

  data() {
    return {
      cronFields: {
        second: '',
        minute: '',
        hour: '',
        day: '',
        month: '',
        weekday: ''
      }
    }
  },

  computed: {
    humanCron() {
      let c = this.trigger.configuration.cron || ''
      return prettycron.toString(c, c.split(' ').length === 6)
    },

    nextCronScheduled() {
      const c = this.trigger.configuration.cron || ''
      return prettycron.getNext(c, c.split(' ').length === 6)
    }
  },

  methods: {
    updateTriggerFromFields() {
      const c = this.cronFields
      this.trigger.configuration.cron = `${c.second || '0'} ${c.minute || '*'} ${c.hour ||
        '*'} ${c.day || '*'} ${c.month || '*'} ${c.weekday || '*'}`
    },

    updateCronFields(cronString) {
      let s = cronString ? cronString.split(' ') : ['0', '', '', '', '', '']
      const cf = this.cronFields

      // We need to be backwards compatible with 5-component cron run-specs
      // In that case the 1st component is the minute not the second.
      var idxOffset = 0
      if (s.length === 6) {
        cf.second = s[0]
        idxOffset = 1
      } else {
        cf.second = '0'
      }

      cf.minute = s[0 + idxOffset]
      cf.hour = s[1 + idxOffset]
      cf.day = s[2 + idxOffset]
      cf.month = s[3 + idxOffset]
      cf.weekday = s[4 + idxOffset]
    }
  },

  mounted() {
    this.updateCronFields(this.trigger.configuration && this.trigger.configuration.cron)
  },

  watch: {
    cronFields: {
      handler: function() {
        this.updateTriggerFromFields()
      },
      deep: true
    },
    trigger: {
      handler: function() {
        this.updateCronFields(this.trigger.configuration && this.trigger.configuration.cron)
      },
      deep: true
    }
  }
}
</script>
